/**
 * Public Route Component
 * Redirects signed-in users to the tool they came from, or the dashboard.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import { resolveAuthReturnPath } from "../../utils/authReturnPath";

function PublicRoute({ children }) {
  const location = useLocation();
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (isSignedIn) {
    const next = resolveAuthReturnPath(location.search) || "/dashboard";
    return <Navigate to={next} replace />;
  }

  return children;
}

export default PublicRoute;





